export default __webpack_public_path__ + "static/media/signup-mobile-3.de9be865.png";